import { formatNumber, roundNumber } from "./general";

/**
 * Gets a ready-to-render price prop of a product considering it as an
 * object with variants.
 * @param product - The top level price and variants from the product
 * to process.
 * @returns - The price as string or number according to variants prop.
 */
export function getProductPriceToRender(
  product: Pick<TProduct, "price" | "variants">
): string {
  let price =
    product.price ||
    (product.variants && product.variants.length > 0
      ? product.variants.reduce((acc, variant) => {
          if (acc === variant.price) return variant.price;

          return "Precios variados";
        }, product.variants[0].price as number | string)
      : "Sin definir");

  if (typeof price === "number") price = `$${formatNumber(price)}`;

  return price;
}

/**
 * Calculates the discount percentage (with '% off' suffix) for a given
 * original and discount prices.
 * @param originalPrice - The product original price.
 * @param discountPrice - The product discount price.
 */
export function getProductDiscountToRender(
  originalPrice: number,
  discountPrice: number
): string {
  const percentage = 100 * (1 - discountPrice / originalPrice);

  const decimals = percentage < 1 ? 2 : 0;

  const roundedPercentage = roundNumber(percentage, decimals);

  return `${roundedPercentage}% off`;
}
